import { INetworkResult } from '@/coreDomainsModule/networkResult';
import { IAggregateBusinessRepository } from '@/coreInfrastructureModule/interfaces/IAggregateBusinessRepository';

/**
 * 集計情報のメモを削除する
 */
export class DeleteAggregateBusinessMemoUseCase {
  private repository: IAggregateBusinessRepository;

  /**
   * コンストラクタ
   * @param repository - 集計情報のリポジトリ
   */
  constructor(repository: IAggregateBusinessRepository) {
    this.repository = repository;
  }

  /**
   * メモを追加/変更する
   * @param aggregateBusinessId - 集計ID
   */
  public async Execute(aggregateBusinessId: string): Promise<INetworkResult<string, Error>> {
    try {
      const result = await this.repository.deleteAggregateBusinessMemo(aggregateBusinessId);
      switch (result.status.type) {
        case 'success':
          return {
            status: {
              type: 'success',
              data: result.status.data,
            },
          };
        case 'error':
          throw result.status.error;
        default:
          throw Error('想定外のエラー');
      }
    } catch (error) {
      return {
        status: {
          type: 'error',
          error: Error('想定外のエラー'),
        },
      };
    }
  }
}
